import React from 'react';
import ReactDOM from 'react-dom';
import { Quote } from './Quote';

const initializeQuote = (
  storeDetails,
  vehicleInformation,
  product,
  product2,
  standardInstallation,
  economyInstallation,
  trailerTireInstallation,
  pricing,
) => {
  const quoteContainer = document.getElementById('quoteContainer');
  const isSplitFitment = product2 !== null;
  const isTrailerTire = product.category === 'Trailer Tires';

  if (quoteContainer) {
    ReactDOM.render(
      <Quote
        storeDetails={storeDetails}
        vehicleInformation={vehicleInformation}
        product={product}
        product2={product2}
        isSplitFitment={isSplitFitment}
        standardInstallation={standardInstallation}
        economyInstallation={economyInstallation}
        trailerTireInstallation={trailerTireInstallation}
        pricing={pricing}
        isTrailerTire={isTrailerTire}
      />,
      quoteContainer,
    );
  }
};

export { initializeQuote };
